import { createSelector } from '@reduxjs/toolkit'
import { IStore } from 'redux/types'

export const selectInvoiceReports = createSelector(
	(state: IStore) => state.invoiceReports,
	(invoiceReports) => invoiceReports
)
